export default "__VITE_ASSET__cfz9MLRC__"